import { useEffect, useState } from "react";
import { Modal, Pressable, StyleSheet } from "react-native";
import Animated, { Easing, ReduceMotion, runOnJS, useAnimatedStyle, useSharedValue, withTiming, } from "react-native-reanimated";
import { useCustomTheme } from "../hooks/useCustomTheme";
export const ThemedModal = ({ children, style, type = "default", onBackdropPress, useOverlay = false, visible, ...rest }) => {
    const { colors } = useCustomTheme();
    const overlayOpacity = useSharedValue(0);
    const slideAnim = useSharedValue(1000);
    const [shouldRenderOverlay, setShouldRenderOverlay] = useState(false);
    useEffect(() => {
        if (useOverlay) {
            if (visible) {
                setShouldRenderOverlay(true);
                overlayOpacity.value = withTiming(1, {
                    duration: 250,
                    easing: Easing.out(Easing.ease),
                    reduceMotion: ReduceMotion.System,
                });
                slideAnim.value = withTiming(0, {
                    duration: 300,
                    easing: Easing.out(Easing.ease),
                    reduceMotion: ReduceMotion.System,
                });
            }
            else {
                overlayOpacity.value = withTiming(0, {
                    duration: 200,
                    easing: Easing.in(Easing.ease),
                    reduceMotion: ReduceMotion.System,
                });
                slideAnim.value = withTiming(1000, {
                    duration: 250,
                    easing: Easing.in(Easing.ease),
                    reduceMotion: ReduceMotion.System,
                }, (finished) => {
                    // Only unmount after animation completes
                    if (finished) {
                        runOnJS(setShouldRenderOverlay)(false);
                    }
                });
            }
        }
    }, [visible, useOverlay, overlayOpacity, slideAnim]);
    const overlayAnimatedStyle = useAnimatedStyle(() => {
        return {
            opacity: overlayOpacity.value,
        };
    });
    const modalAnimatedStyle = useAnimatedStyle(() => {
        return {
            transform: useOverlay ? [{ translateY: slideAnim.value }] : [],
        };
    });
    const handleBackdropPress = () => {
        if (onBackdropPress) {
            onBackdropPress();
        }
    };
    const modalContent = (<Pressable style={styles.centeredView} onPress={handleBackdropPress}>
      <Animated.View style={[
            {
                backgroundColor: type === "default"
                    ? colors.background
                    : type === "success"
                        ? colors.success
                        : type === "danger"
                            ? colors.danger
                            : type === "warning"
                                ? colors.warning
                                : colors.background,
            },
            modalAnimatedStyle,
            style,
        ]} onStartShouldSetResponder={() => true}>
        {children}
      </Animated.View>
    </Pressable>);
    if (useOverlay) {
        // Use overlay approach for RFID compatibility with animations
        return shouldRenderOverlay ? (<Animated.View style={[
                StyleSheet.absoluteFillObject,
                styles.overlay,
                { backgroundColor: `${colors.modalBackground}90` },
                overlayAnimatedStyle,
            ]}>
        {modalContent}
      </Animated.View>) : null;
    }
    // Use standard Modal
    return (<Modal {...rest} visible={visible} backdropColor={`${colors.modalBackground}50`} animationType="slide">
      {modalContent}
    </Modal>);
};
const styles = StyleSheet.create({
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    overlay: {
        zIndex: 1000,
    },
});
//# sourceMappingURL=ThemedModal.js.map